const researchPapers = [
  {
    title: 'Safety-Critical Edge-Case Testing for High-Speed Autonomy',
    href: '/research/safety-critical-edge-case-testing.pdf',
    collaborators: 'With Erick Brito',
  },
  {
    title: 'Grasp Planning with Sawyer',
    href: '/research/grasp-planning-with-sawyer.pdf',
    collaborators: 'With Matthew Sulistijowadi and Jackson Hilton',
  },
  {
    title: 'State Estimation',
    href: '/research/state-estimation.pdf',
    collaborators: 'With Matthew Sulistijowadi and Jackson Hilton',
  },
];

export default researchPapers;
